var $ = require('jquery');

var noop = function() {};
var APIHelper = {};
/**
 * @param url: Can be a normal url or a path to a JSON file.
 * @param success: The callback function for when the request succeeds.
 * @param fail: The callback function for when the request has failed.
 **/
APIHelper.get = function(url, success, fail) {
  // If these callbacks are undefined, set them to a no operation function.
  success = success || noop;
  fail = fail || noop;
  var jsonIndex = url.indexOf('.json');
  // If the url is to a JSON file.
  if (jsonIndex !== -1) {
    // Only use the url up (and including) the .json extension.
    // If we're using a json file we don't need parameters.
    $.getJSON(url.substring(0, jsonIndex + 5), success).fail(fail);
  }
  // Else it is an API call.
  else {
    $.get({ url: url, cache: false, success: success }).fail(fail);
  }
};
/**
 * @param url: Can be a normal url or a path to a JSON file.
 * @param success: The callback function for when the request succeeds.
 * @param fail: The callback function for when the request has failed.
 * @param always: The callback function that should always be called regardless of outcome.
 **/
APIHelper.post = function(url, data, success, fail, always) {
  // If these callbacks are undefined, set them to a no operation function.
  success = success || noop;
  fail = fail || noop;
  always = always || noop;
  var jsonIndex = url.indexOf('.json');
  // If the url is to a JSON file.
  if (jsonIndex !== -1) {
    $.getJSON(url.substring(0, jsonIndex + 5), success).fail(fail);
  } else {
    $.post(url, data, success)
      .fail(fail)
      .always(always);
  }
};

APIHelper.delete = function(url, data, success, fail) {
  // If these callbacks are undefined, set them to a no operation function.
  success = success || noop;
  fail = fail || noop;
  var jsonIndex = url.indexOf('.json');
  // If the url is to a JSON file.
  if (jsonIndex !== -1) {
    $.getJSON(url.substring(0, jsonIndex + 5), success).fail(fail);
  } else {
    $.ajax({
      url: url,
      type: 'DELETE',
      success: success,
      error: fail
    });
  }
};

APIHelper.QcDelete = function(url, data, success, fail) {
  success = success || noop;
  fail = fail || noop;
  var jsonIndex = url.indexOf('.json');
  // If the url is to a JSON file.
  if (jsonIndex !== -1) {
    $.getJSON(url.substring(0, jsonIndex + 5), success).fail(fail);
  } else {
    $.ajax({
      url: url,
      type: 'DELETE',
      success: success,
      error: fail,
      contentType: 'application/json',
      data: JSON.stringify(data),
      dataType: 'json',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
  }
};

APIHelper.QcPost = function(url, data, success, fail) {
  success = success || noop;
  fail = fail || noop;
  var jsonIndex = url.indexOf('.json');
  // If the url is to a JSON file.
  if (jsonIndex !== -1) {
    $.getJSON(url.substring(0, jsonIndex + 5), success).fail(fail);
  } else {
    $.ajax({
      url: url,
      type: 'POST',
      success: success,
      error: fail,
      contentType: 'application/json',
      data: JSON.stringify(data),
      dataType: 'json',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
  }
};

module.exports = APIHelper;
